"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.toggleModal = exports.setSelected = exports.linkFailed = exports.linkSuccess = exports.linkRequest = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = void 0;
const ActionTypes = require("../../actionTypes/project/customerUserGroups");
// Fetch
const fetchRequest = (customerId) => ({
    type: ActionTypes.FETCH_REQUEST,
    payload: customerId
});
exports.fetchRequest = fetchRequest;
const fetchSuccess = (groups) => ({
    type: ActionTypes.FETCH_SUCCESS,
    payload: groups
});
exports.fetchSuccess = fetchSuccess;
function fetchFailed(error) {
    return {
        type: ActionTypes.FETCH_FAILED,
        payload: error
    };
}
exports.fetchFailed = fetchFailed;
// Link
const linkRequest = (project, userGroup) => ({
    type: ActionTypes.LINK_REQUEST,
    payload: {
        project,
        userGroup
    }
});
exports.linkRequest = linkRequest;
const linkSuccess = () => ({
    type: ActionTypes.LINK_SUCCESS
});
exports.linkSuccess = linkSuccess;
function linkFailed(error) {
    return {
        type: ActionTypes.LINK_FAILED,
        payload: error
    };
}
exports.linkFailed = linkFailed;
// Others
const setSelected = (group) => ({
    type: ActionTypes.SET_SELECTED,
    payload: group
});
exports.setSelected = setSelected;
const toggleModal = () => ({
    type: ActionTypes.TOGGLE_MODAL
});
exports.toggleModal = toggleModal;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=customerUserGroups.js.map